import React from 'react';
import { AIcon } from '../../atoms/AIcon/index';
import { MTextBlockBasic } from '../../molecules/MTextBlockBasic/index';
import * as Styled from './OCardMiniIcon.styles';
import type { OCardMiniIconProps } from './OCardMiniIcon.types';

export const OCardMiniIcon: React.FC<OCardMiniIconProps> = ({
  externalLink = false,
  ctaLink,
  aIcon,
  mTextBlockBasic,
  className,
  ...rest
}) => {
  const content = (
    <Styled.Wrapper className={className} {...rest}>
      {aIcon && (
        <Styled.IconWrapper>
          <AIcon icon={aIcon.icon} size={aIcon.size} />
        </Styled.IconWrapper>
      )}
      {mTextBlockBasic && (
        <Styled.TextBlockWrapper alignment={mTextBlockBasic.alignment}>
          <MTextBlockBasic
            alignment={mTextBlockBasic.alignment}
            aEyebrow={mTextBlockBasic.aEyebrow}
            aSubheader={mTextBlockBasic.aSubheader}
            aBody={mTextBlockBasic.aBody}
          />
        </Styled.TextBlockWrapper>
      )}
    </Styled.Wrapper>
  );

  if (externalLink && ctaLink) {
    return (
      <Styled.ExternalLinkWrapper href={ctaLink} target="_blank" rel="noopener noreferrer">
        {content}
      </Styled.ExternalLinkWrapper>
    );
  }

  if (ctaLink) {
    return <Styled.LinkWrapper href={ctaLink}>{content}</Styled.LinkWrapper>;
  }

  return content;
};
